module.exports = __webpack_public_path__ + "img/main_section_img7.23621593.png";